import { isEmpty, isNil } from 'lodash';
import { MouseEvent } from 'react';

/*
 * Dragging to select text fires a click on mouseup; a click handler that
 * navigates (e.g. opening a card from a row) should ignore it. Only a
 * selection anchored inside the clicked element counts — a stale selection
 * elsewhere on the page doesn't block the click.
 */
export function isTextSelectionClick(event: MouseEvent<HTMLElement>): boolean {
  const selection = window.getSelection();
  if (isNil(selection) || selection.isCollapsed || isEmpty(selection.toString())) {
    return false;
  }
  return event.currentTarget.contains(selection.anchorNode);
}
